// utils/versionUtils.js
//
// JD version helpers. The BACKEND decides which version of a JD is the latest and which is the last
// published one (Latest JD Version Service, ticket sb-monarch-backend#1269): every row of /versions and
// /rnc_versions carries `is_latest` (the latest version this viewer may see) and
// `latest_published_sb_unique_id`, and the lists come back newest first by version number.
// The UI never compares or sorts version numbers itself: a JS float or text compare puts "1.10" below
// "1.9" and "9.00" above "10.00".

const HISTORICAL = 'HISTORICAL';
const PUBLISHED = 'PUBLISHED';

// The row the backend marked as the latest version this viewer may see, or null when it marked none.
export const getLatestVersionRow = (versions) =>
  (Array.isArray(versions) ? versions.find((v) => v?.is_latest === true) : null) ?? null;

// The row of the JD's last published version (PUBLISHED or UNPUBLISHED), as the backend names it.
export const getLatestPublishedRow = (versions) => {
  if (!Array.isArray(versions)) return null;
  const id = versions.find((v) => v?.latest_published_sb_unique_id)?.latest_published_sb_unique_id;
  return (id && versions.find((v) => v?.sb_unique_id === id)) || null;
};

// The row of the version that is live now: the backend's last published version, when it is PUBLISHED.
export const getLivePublishedRow = (versions) => {
  const row = getLatestPublishedRow(versions);
  return row?.jd_status === PUBLISHED ? row : null;
};

// Who wrote a version, from its number: the AI writes the x.00 versions, a person writes the rest.
// Reads the minor part as an integer (never as a decimal): "2.0" is AI-written, "1.10" is a human edit.
export const getVersionSource = (version) => {
  const minor = parseInt(String(version ?? '').split('.')[1], 10);
  if (Number.isNaN(minor)) return '';
  return minor === 0 ? 'AI-GENERATED' : 'HUMAN-EDITED';
};

// Dropdown label: "V1.01 (HUMAN-EDITED)". A HISTORICAL version (an older version left in a temporary
// status when the JD moved on) shows its source only, e.g. "V1.00 (AI-GENERATED)", never the word HISTORICAL.
export const versionOptionLabel = ({ version, tag, jd_status: status } = {}) => {
  const label = tag === HISTORICAL || status === HISTORICAL ? getVersionSource(version) : tag;
  return label ? `V${version} (${label})` : `V${version}`;
};
